<template>
  <table data-sig-version="1" border="1" cellpadding="0" width="530" :style="styleTop">
     <tbody>
        <tr style="">
           <td width="59%" style="width:59.32%;border:none;padding:3.0pt .75pt .75pt .75pt;">
              <div>
                 <p style="margin:0; padding: 0;"><span style="font-size:12.0pt;font-family:&quot;Arial&quot;,sans-serif">{{fullName}}
                    <u></u><u></u></span>
                 </p>
              </div>
              <div v-if="title">
                <p style="margin:0; padding: 0;"><b><span style="font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif" v-html="titleHtml"></span></b></p>
              </div>
              <div v-if="mobilePhone">
                 <p style="margin:0; padding: 0;"><span style="font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Mobile: {{mobilePhone}}
                    <u></u><u></u></span>
                 </p>
              </div>
              <div v-if="workPhone">
                 <p style="margin:0; padding: 0;"><span style="font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Phone: {{ workPhone }}
                    <u></u><u></u></span>
                 </p>
              </div>
              <div>
                 <p style="margin:0; padding: 0;"><span style="font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"><a href="mailto:{{email}}" target="_blank">{{email}}</a>
                    <u></u><u></u></span>
                 </p>
              </div>
              <div v-if="bookingLink">
                 <p style="margin:0; padding: 0;"><span style="font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"><a :href="bookingLink" target="_blank">Book a Meeting</a>
                    <u></u><u></u></span>
                 </p>
              </div>
           </td>
           <td width="39%" style="width:39.54%;border:none;padding:4.25pt .75pt;">
             <p align="right" style="margin:0; padding: 0;text-align:right"><a :href="brand.website" target="_blank"><span style="font-family:&quot;Arial&quot;,sans-serif;color:blue;text-decoration:none"><img border="0" width="200"  style="width:2.0833in;" :src="brand.logoSrc" :alt="brand.name" class="CToWUd" data-bit="iit"></span></a><span style="font-family:&quot;Arial&quot;,sans-serif"><u></u><u></u></span></p>
           </td>
        </tr>
        <tr style="">
           <td width="99%" colspan="2" :style="styleBottom">
             <p align="center" style="margin:0; padding: 0;text-align:center"><span style="font-size:9.0pt;font-family:&quot;Helvetica&quot;,sans-serif;color:white;letter-spacing:.75pt">
               <template v-if="addressStreet">
                 {{addressStreet}} <span>&#183;</span> {{ addressLocality }}, {{ addressRegion }} {{ addressPostalCode }}
               </template>
               <template v-if="addressStreet && tollFree">
                  <span> &#183; </span>
               </template>
               <template v-if="tollFree">
                 {{tollFree}}
               </template>
               <u></u><u></u></span>
              </p>
           </td>
        </tr>
        <tr style="">
           <td width="99%" colspan="2" style="width:99.24%;border:none;padding:1.5pt .75pt .75pt .75pt;">
              <p align="center" style="margin:0; padding: 0; text-align:center"><b><span style="font-size:8.5pt;font-family:&quot;Helvetica&quot;,sans-serif">Your privacy is important to us. Please review our
                 <a href="http://www.atlastravelandtechnology.com/privacy-policy.php" target="_blank">privacy policy.</a>
                 <u></u><u></u></span></b>
              </p>
           </td>
        </tr>
        <tr v-if="false">
          <!--GBTA Banner, disabled till next year -->
          <td width="99%" colspan="2" style="width:99.24%;border:none;padding:1.5pt .75pt .75pt .75pt;">
            <p align="center" style="margin:0; padding: 0; text-align:center">
            <img border="0" src="https://images.atlastravel.com/signatures/GBTA_2024_email_banner.png" alt="GBTA 2024 - Join us at booth #4341!">
            </p>
          </td>
        </tr>
     </tbody>
  </table>
</template>

<script>
export default {
  props: {
    addressLocality: String,
    addressPostalCode: String,
    addressRegion: String,
    addressStreet: String,
    bookingLink: String,
    brand: Object,
    email: String,
    fullName: String,
    mobilePhone: String,
    shouldDisplayCell: Boolean,
    showGbtaBanner: Boolean,
    title: String,
    tollFree: String,
    workPhone: String,
  },

  computed: {
    titleHtml() {
      return this.title.replace(/;/g, '<br>') + "<u></u><u></u>";
    },

    styleTop() {
      return `width:397.5pt;border:none;border-top:solid ${this.brand.color} 1.5pt`;
    },

    styleBottom() {
      return `width:99.24%;border:none;background:${this.brand.color};padding:3.0pt .75pt .75pt .75pt;`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .MsoNormal {
      margin: 0;
      padding: 0px 0;
    }
</style>
